// extracted by mini-css-extract-plugin
export default {"candyMachineSpecifications":"CandyMachineInfo_candyMachineSpecifications__5Tk51"};